export default __webpack_public_path__ + "dfc3ece2b41dca6fb13b0aba709cd930.png";